import {
  TableFooter,
  TableContainerStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import {
  BlockIcon,
  CheckOutLineIcon,
  DeleteIcon,
  EditIcon,
  LockIcon,
  StatusIcon
} from 'components/Icons'
import { EffectiveTableData } from 'services/Supplier/LogicalEffective'
import { FORMAT, SPACING } from 'utils'

interface TableProps {
  effectiveList: EffectiveTableData[]
  setPage: any
  pageCount: number
  setRowsPerPage: any
  rowsPerPage: number
  handleDeleteEfetivoContrato: (idEfetivoLogicoContrato: number) => void
  page: number
  handleClickRevalidate: (
    idEfetivoLogico: number,
    nmColaborador: string
  ) => void
  handleClickBlock: (
    idEfetivoLogico: number,
    nmColaborador: string,
    maisDeUmContrato: boolean,
    cdCpf: string,
    status?: string
  ) => void
  handleClickUnlock: (
    idEfetivoLogico: number,
    nmColaborador: string,
    maisDeUmContrato: boolean,
    cdCpf: string
  ) => void
  handleEditEffective: (idEfetivoLogico: number) => void
}

export const TableRegisterEffectives = ({
  effectiveList,
  setPage,
  pageCount,
  rowsPerPage,
  setRowsPerPage,
  handleDeleteEfetivoContrato,
  page,
  handleClickRevalidate,
  handleClickBlock,
  handleClickUnlock,
  handleEditEffective
}: TableProps) => {
  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center">Nome</TableCellStyled>
              <TableCellStyled align="center">CPF/Passaporte</TableCellStyled>
              <TableCellStyled align="center">Matricula</TableCellStyled>
              <TableCellStyled align="center">Data Nascimento</TableCellStyled>
              <TableCellStyled align="center">Função</TableCellStyled>
              <TableCellStyled align="center">Data Validade Lógica</TableCellStyled>
              <TableCellStyled align="center">Ult. Atualização</TableCellStyled>
              <TableCellStyled align="center">Qtd Dias</TableCellStyled>
              <TableCellStyled align="center" padding="checkbox">
                Status
              </TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {effectiveList?.length > 0 &&
              effectiveList.map((row) => (
                <TableRowStyled key={row.idEfetivoLogico}>
                  <TableCellStyled align="justify">
                    {row.nmColaborador}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.documento(row.cdCpf)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.matricula || '- - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.formatDDMMYYYY(row.dtNascimento)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.txFuncao}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.flMatricula
                      ? FORMAT.formatDDMMYYYY(row.dtValidade)
                      : '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.flMatricula
                      ? FORMAT.formatDDMMYYYY(row.dtUltAtualizacao)
                      : '- - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.flMatricula ? row.qtDias : 0}
                  </TableCellStyled>
                  <TableCellStyled align="center" padding="checkbox">
                    <StatusIcon
                      marginLeft="auto"
                      marginRight="auto"
                      colorIcon={row.statusColor}
                    />
                  </TableCellStyled>
                  <TableCellStyled hasNoPointer align="center">
                    <CheckOutLineIcon
                      onClick={() =>
                        handleClickRevalidate(
                          row.idEfetivoLogico,
                          row.nmColaborador
                        )
                      }
                      cursor="pointer"
                      disabled={
                        (row.statusBloqueio !== 'L' &&
                          row.statusBloqueio !== 'P') ||
                        !row.flMatricula
                      }
                    />
                    <EditIcon
                      marginLeft={SPACING.spacing5}
                      marginRight={SPACING.spacing5}
                      onClick={() => handleEditEffective(row.idEfetivoLogico)}
                      cursor="pointer"
                    />
                    {row.statusBloqueio === 'B' || row.statusBloqueio === 'D' ? (
                      <LockIcon
                        disabled={!row.flMatricula || row.statusBloqueio === 'D'}
                        onClick={() =>
                          handleClickUnlock(
                            row.idEfetivoLogico,
                            row.nmColaborador,
                            row.flMaisDeUmContrato,
                            row.cdCpf
                          )
                        }
                        cursor="pointer"
                      />
                    ) : (
                      <BlockIcon
                        disabled={!row.flMatricula}
                        marginRight={SPACING.spacing5}
                        onClick={() =>
                          handleClickBlock(
                            row.idEfetivoLogico,
                            row.nmColaborador,
                            row.flMaisDeUmContrato,
                            row.cdCpf
                          )
                        }
                        cursor="pointer"
                      />
                    )}
                    <DeleteIcon
                      onClick={() =>
                        handleDeleteEfetivoContrato(row.idEfetivoLogicoContrato)
                      }
                      cursor="pointer"
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={effectiveList}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
